import formUserManage from './form-maintenance-userManage.vue';


// 为组件添加 install 方法，用于按需引入
formUserManage.install = function (Vue) {
    Vue.component(formUserManage.name, formUserManage)
}

export default formUserManage